/*******************************************************
 * EXPLOITATION SERVICE
 *******************************************************/

"use strict";


/**
 * Module SERVICES
 */
angular.module("exploitation")


/**
     * Service for the comptage module
     */
	.factory("ExploitationVehicleJourneyService", ["$http", "SharedProperties", "ENV", "Utils", "CONSTANTS", function ($http, SharedProperties, ENV, Utils, CONSTANTS) {
		return {
			linkCoursesToTimetables: linkCoursesToTimetables,
			unlinkCourseFromTimetable: unlinkCourseFromTimetable
		};

		function linkCoursesToTimetables(courses, timetables) {
			return $http.post(ENV.API_URL + "/exploitation/course/timetablesAssociation", {
				courseIds: courses,
				timetableIds: timetables.map(function (timetable) {
					return timetable.id;
				})
			});
		}

		function unlinkCourseFromTimetable(course, timetable) {
			return $http.delete(ENV.API_URL + "/exploitation/course/" + course.id + "/timetables/" + timetable.id);
		}
	}]);
